import { Expose } from 'class-transformer';

export class TitleDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
